import React from "react";
import { Modal, Button } from "react-bootstrap";

const DeleteModalPackage = ({ show, handleClose, handleDelete }) => {
  return (
    <Modal
      show={show}
      onHide={handleClose}
      size="md"
      aria-labelledby="delete-alert-modal-title"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="delete-alert-modal-title">Confirm Deletion</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Do you really want to delete these records?</p>
        <p className="text-danger">
          You can't view this in your list anymore if you delete!
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button style={{background:"#359383", border:"0px solid black"}} onClick={handleClose}>
          Cancel
        </Button>
        <Button style={{background:"#212d60", border:"0px solid black"}} onClick={handleDelete}>
          Delete
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteModalPackage;
